import React, { useState } from "react"
import { withTranslation } from 'react-i18next'
import PropTypes from 'prop-types'
import { ArrowSquareDown, ArrowSquareUp } from "phosphor-react"
import { getPaginationInfo } from '../../lib/lib'

const Select = ({ options, updateItems, lang, token, page, limit, t }) => {
    const [isOpen, setIsOpen] = useState(false)
    const [selectedOption, setSelectedOption] = useState(options[0])

    const toggling = () => {
        if (options.length > 1) setIsOpen(!isOpen)
    }

    const onOptionClicked = (value) => () => {
        setSelectedOption(value)
        setIsOpen(false)
        const { start, end } = getPaginationInfo({ page, limit })
        updateItems({ lang, token, start, end, sort: value })
    }
    return (
        <div className="custom-select-container">
            <div className="custom-select-header" onClick={toggling}>
                <span className="text sm-font-size">{t(`catalog-sort-${selectedOption}`)}</span>
                {isOpen ? <ArrowSquareUp className="icon" size={20} /> : <ArrowSquareDown className="icon" size={20} />}
            </div>
            {(isOpen && options.length > 1) && (
                <div className="custom-select-list-container">
                    <ul className="custom-select-list">
                        {options.map((option) => selectedOption !== option && (
                            <li className="custom-select-list-item sm-font-size" onClick={onOptionClicked(option)} key={Math.random()}>
                                {t(`catalog-sort-${option}`)}
                            </li>
                        ))}
                    </ul>
                </div>
            )}
        </div>
    )
}

Select.propTypes = {
    options: PropTypes.array,
    updateItems: PropTypes.func,
    lang: PropTypes.string,
    token: PropTypes.string,
    page: PropTypes.number,
    limit: PropTypes.number,
    t: PropTypes.func,
}

export default withTranslation()(Select)



// WEBPACK FOOTER //
// ./src/components/UI/Select.jsx